import { tableFrCATranslations } from "../components/table/_lang/fr-CA";
import { editableFieldFrCATranslations } from "../controls/editable-field/_lang/fr-CA";
import { fileFrCATranslations } from "../controls/file/_lang/fr-CA";
import { taggedInputFrCATranslations } from "../controls/tagged-input/_lang/fr-CA";
import { draftFrCATranslations } from "../hooks/_lang/fr-CA";
import type { RayaLucariaTranslationKey } from "./en-US";

export const rayaLucariaFrCA: Record<RayaLucariaTranslationKey, string> = {
  ...tableFrCATranslations,
  ...draftFrCATranslations,
  ...editableFieldFrCATranslations,
  ...fileFrCATranslations,
  ...taggedInputFrCATranslations,
  apply: "Appliquer",
  cancel: "Annuler",
  close: "Fermer",
  dismiss: "Fermer",
  saving: "Enregistrement...",
  saved: "Enregistré",
  clear: "Effacer",
  confirm: "Confirmer",
  filter: "Filtrer",
  filterValue: "Valeur du filtre",
  expandMenu: "Développer le menu",
  collapseMenu: "Réduire le menu",
  openMenu: "Ouvrir le menu",
  mainNavigation: "Navigation principale",
  secondaryNavigation: "Navigation secondaire",
  navigationMenu: "Menu de navigation",
  skipToContent: "Passer au contenu principal",
  aboutField: "À propos de {{label}}",
  moreInformation: "Plus d'information",
  passcodeLegend: "Saisissez le code de {{count}} caractères",
  passcodeCharacter: "Caractère {{index}} sur {{count}}",
  passcodeIncomplete: "Saisissez les {{count}} caractères",
  reorderInstructions:
    "Appuyez sur Espace ou Entrée pour saisir. Utilisez les flèches pour déplacer. Appuyez sur Espace ou Entrée pour déposer, ou sur Échap pour annuler.",
  reorderPickedUp: "{{name}} saisi. Position {{position}} sur {{total}}.",
  reorderMoved: "{{name}} déplacé à la position {{position}} sur {{total}}.",
  reorderDropped: "{{name}} déposé à la position {{position}} sur {{total}}.",
  reorderCancelled:
    "Réorganisation annulée. {{name}} est revenu à la position {{position}} sur {{total}}.",
  reorderSaving: "Enregistrement du nouvel ordre.",
  reorderSaved: "Nouvel ordre enregistré.",
  reorderSaveFailed:
    "Impossible d'enregistrer le nouvel ordre. {{name}} est à la position {{position}} sur {{total}}.",
  reorderRoleDescription: "déplaçable",
  reorderHandleColumn:
    "Réorganiser la colonne {{name}}, position {{position}} sur {{total}}",
  reorderHandleLineItem:
    "Réorganiser la ligne {{name}}, position {{position}} sur {{total}}",
  reorderHandleDiscount:
    "Réorganiser la remise {{name}}, position {{position}} sur {{total}}",
  reorderLineItemFallback: "ligne {{position}}",
  reorderDiscountFallback: "remise {{position}}",
  reorderHandleLineItemNameless:
    "Réorganiser la ligne, position {{position}} sur {{total}}",
  reorderHandleDiscountNameless:
    "Réorganiser la remise, position {{position}} sur {{total}}",
  reorderRowActionsTip: "Actions",
  reorderRowActionsName:
    "Actions pour {{name}}, position {{position}} sur {{total}}",
  reorderMoveUp: "Monter",
  reorderMoveDown: "Descendre",
};
